export default __webpack_public_path__ + "static/media/medium-light.ca035283.svg";